// extracted by mini-css-extract-plugin
module.exports = {"container":"sala-de-espera_container__2-IME"};